/** @jsxImportSource @emotion/react */
import { lighten, TypographyProps } from '@material-ui/core'
import Typography from '@signal/components/Typography'
import estyled, { ecss } from '@signal/theme/emotion'
import {
  getColorErrorSelector,
  getColorPrimarySelector
} from '@signal/theme/selectors'

export type InputContainerProps = {
  $stretch?: boolean
  $height?: number
}

export const InputContainer = estyled.div<InputContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ $stretch }) =>
    $stretch &&
    `
    align-self: stretch; 
  `}

  .label {
    font-size: 15px;
    font-weight: 600;
  }
`

export const InputWrapper = estyled.div<InputContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  height: ${({ $height }) => $height}px;
`

export const LeftOrnament = estyled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  pointer-events: auto;
  color: ${({ theme }) => theme.palette.text.secondary};
  opacity: 0.55;

  * {
    pointer-events: auto;
  }
`

export const StyledInput = estyled.input<{
  $height?: number
  $error?: boolean
  $hasLeftOrnament?: boolean
  $leftOrnamentWidth?: number
}>`
  width: 100%;
  height: 100%;
  padding: 5px 14px;
  box-sizing: border-box;
  ${({ $hasLeftOrnament, $leftOrnamentWidth }) =>
    $hasLeftOrnament && `padding-left: ${$leftOrnamentWidth || 36}px;`}
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 30px;
  font-size: 15px;
  box-shadow: inset 0 3px 1px 0 rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s ease-in-out;
  &::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-style: italic;
  }

  ${({ $error, theme }) =>
    $error
      ? ecss`
          border-color: ${getColorErrorSelector()(theme)};
        `
      : ecss``}

  &:focus {
    outline: none;
    border-color: ${({ theme }) =>
      lighten(getColorPrimarySelector()(theme), 0.7)} !important;
  }
`

export const ErrorMessage = estyled<TypographyProps>(Typography)`
  font-size: 12px !important;
  color: ${getColorErrorSelector()} !important;
  font-style: italic !important;
`
